import React from 'react';
import extend from 'extend';

class MessageModal extends React.Component {

	onClick(index) {
		if (this.props.onResult != null) {
			this.props.onResult(this.props.buttons[index].value);	
		}

		this.props.app.modalHide();
	}

	render() {
		const buttons = this.props.buttons.map((button, index) => {

			let textStyle = 
			button.style === 'confirm' ? this.props.confirmTextStyle :
			button.style === 'cancel' ? this.props.cancelTextStyle : {};

			textStyle = extend({
				flexGrow: 1,
				lineHeight: this.props.buttonHeight + 'px',
				textAlign: 'center',
				borderRight: index === this.props.buttons.length - 1 ? undefined : '1px solid #EBEBEB',
				borderTop: '1px solid #EBEBEB'
			}, textStyle);

			return (
				<div 
				style={textStyle}
				key={index}
				onClick={this.onClick.bind(this, index)}>
					{button.title}
				</div>
			);
		})

		return (
			<div className='MessageModal'>
				<div className='MessageModal-message'>{this.props.message}</div>
				<div className='MessageModal-button-container' style={{
					height: this.props.buttonHeight
				}}>
					{buttons}
				</div>
			</div>
		);
	}
}

MessageModal.defaultProps = {
	buttonHeight: 44, 
	confirmTextStyle: {
		color: '#007AFF',
		fontSize: 18,
		fontWeight: 'bold'
	},

	cancelTextStyle: {
		color: '#007AFF',
		fontSize: 18
	}
}

MessageModal.presets = {};

MessageModal.presets.simple = {
	message: '<placeholder>',
	buttons: [{
		title: 'OK',
		style: 'confirm'
	}]
};

MessageModal.presets.prompt = {
	message: 'Are you sure?',
	buttons: [{
		title: 'Cancel',
		style: 'cancel',
		value: false
	}, {
		title: 'Yes',
		style: 'confirm',
		value: true
	}]
};
MessageModal.presets.continue = {
	message: 'Would you like to continue?',
	buttons: [{
		title: 'No thanks',
		style: 'cancel',
		value: false
	},
	{
		title: 'Let\'s go',
		style: 'confirm',
		value: true
	}]
}

export default MessageModal;


// WEBPACK FOOTER //
// ./src/components/messagemodal.jsx